import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";

function Footer() {
  const { siteData } = useContext(AuthContext);
  return (
    <footer id="footer" className="bg-neutral-900 text-gray-300 font-poppins">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <img
                src={siteData?.logo}
                alt="Homeo Hopes Logo"
                className="w-10 h-10 rounded-full"
              />
              <span className="text-xl font-semibold text-white">
                {siteData?.name}
              </span>
            </div>
            <p className="text-sm">
              Dr. Anoop Choudhary's Homeo Hopes is a trusted homeopathic clinic
              in Bhopal, providing comprehensive healthcare solutions through
              natural healing methods.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-white mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="#hero"
                  className="hover:text-emerald-400 transition-colors"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="#about"
                  className="hover:text-emerald-400 transition-colors"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="hover:text-emerald-400 transition-colors"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="#specialties"
                  className="hover:text-emerald-400 transition-colors"
                >
                  Specialties
                </a>
              </li>
              <li>
                <a
                  href="#testimonials"
                  className="hover:text-emerald-400 transition-colors"
                >
                  Testimonials
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="hover:text-emerald-400 transition-colors"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-white mb-4">
              Our Services
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="#specialties"
                  className="hover:text-emerald-400 transition-colors"
                >
                  Skin Treatment
                </a>
              </li>
              <li>
                <a
                  href="#specialties"
                  className="hover:text-emerald-400 transition-colors"
                >
                  Hair Treatment
                </a>
              </li>
              <li>
                <a
                  href="#specialties"
                  className="hover:text-emerald-400 transition-colors"
                >
                  Pediatric Care
                </a>
              </li>
              <li>
                <a
                  href="#specialties"
                  className="hover:text-emerald-400 transition-colors"
                >
                  Chronic Diseases
                </a>
              </li>
              <li>
                <a
                  href="#specialties"
                  className="hover:text-emerald-400 transition-colors"
                >
                  Women's Health
                </a>
              </li>
              <li>
                <a
                  href="#specialties"
                  className="hover:text-emerald-400 transition-colors"
                >
                  Mental Health
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-white mb-4">
              Contact Info
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-emerald-400 flex-shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  ></path>
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  ></path>
                </svg>
                <span>
                  G-4, Jeevan Sagar Apartment, Malviya Nagar, Bhopal - 462003
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-emerald-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  ></path>
                </svg>
                <a
                  href="tel:9425024526"
                  className="hover:text-emerald-400 transition-colors"
                >
                  9425024526
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-emerald-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  ></path>
                </svg>
                <a
                  href="mailto:homeohopes@gmail.com"
                  className="hover:text-emerald-400 transition-colors"
                >
                  homeohopes@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-neutral-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm">© 2024 Homeo Hopes. All rights reserved.</p>
            <div className="flex space-x-6">
              <a
                href="/"
                className="text-sm hover:text-emerald-400 transition-colors"
              >
                Privacy Policy
              </a>
              <a
                href="/"
                className="text-sm hover:text-emerald-400 transition-colors"
              >
                Terms of Service
              </a>
              <a
                href="/"
                className="text-sm hover:text-emerald-400 transition-colors"
              >
                Cookie Policy
              </a>

              <Link
                to="/login"
                className="text-sm hover:text-emerald-400 transition-colors"
              >
                Admin Login
              </Link>
            </div>
          </div>
        </div>
      </div>

      <button
        id="scrollToTop"
        className="fixed bottom-8 right-8 bg-emerald-500 text-white p-3 rounded-full shadow-lg hover:bg-emerald-600 transition-colors hidden"
        onClick={() => window.scrollTo(0, 0)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 10l7-7m0 0l7 7m-7-7v18"
          ></path>
        </svg>
      </button>
    </footer>
  );
}

export default Footer;
